import type { CarouselImage } from '@shared-components/ImageCarousel/ImageCarousel.entity';

const FALLBACK_IMAGE: CarouselImage = {
  url: '',
  isRelative: false,
  isFallback: true,
};

const IMAGES_TAB_NAME = 'images';
const VIDEO_TAB_NAME = 'video';
const IMAGES_360_TAB_NAME = 'images360';

export { FALLBACK_IMAGE, IMAGES_TAB_NAME, VIDEO_TAB_NAME, IMAGES_360_TAB_NAME };
